module.exports = __webpack_public_path__ + "img/login-page-enter.31b562e3.png";